import useHomeText from 'hooks/useHomeText';
import useScrolledShadow from 'hooks/useScrolledShadow';
import AgendaHeader from './AgendaHeader';
import AppointmentItem from './AppointmentItem';
import AppointmentsToPlace from './AppointmentsToPlace';
import { CARD_CLASS } from 'utils/surfaceClasses';

/**
 * « Planning »: the appointments to place, then today's appointments. Every
 * appointment of the day is rendered: the list scrolls inside the card while
 * the head (title, buttons, « to place » banner) stays in place and casts a
 * shadow once the list has scrolled. `onNavigate` gets `planning` or
 * `placeAppointments`.
 */
const AgendaCard = ({ appointments, toPlace, onOpen, onAdd, onNavigate }) => {
  const { text } = useHomeText();
  const { ref: watchListScroll, isScrolled } = useScrolledShadow();

  return (
    <section className={`flex max-h-full min-h-0 flex-col px-4 pb-4 pt-3 ${CARD_CLASS}`}>
      <div
        data-testid="agenda-head"
        className={`relative z-10 -mx-4 flex flex-col gap-3 px-4 pb-3 transition-shadow duration-150 ${
          isScrolled ? 'shadow-[0_4px_6px_-4px_rgba(17,24,39,0.12)]' : ''
        }`}
      >
        <AgendaHeader onOpenPlanning={() => onNavigate('planning')} onAdd={onAdd} />
        {toPlace.total > 0 && (
          <AppointmentsToPlace
            total={toPlace.total}
            beforeTomorrow={toPlace.beforeTomorrow}
            onClick={() => onNavigate('placeAppointments')}
          />
        )}
      </div>
      {!appointments.length && (
        <p className="text-sm text-gray-400">
          {text(toPlace.total ? 'agenda.empty' : 'agenda.emptyFree')}
        </p>
      )}
      <div
        ref={watchListScroll}
        data-testid="agenda-list"
        className="thin-scrollbar flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto"
      >
        {appointments.map((appointment) => (
          <AppointmentItem key={appointment.id} appointment={appointment} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
};

export default AgendaCard;
